import { Component, Input, OnInit } from '@angular/core';
import { ReturnViewService } from '../../../return-view.service';
import {
  INCOME_FORM_TAX_EXEMPTED_INCOME_KEYS,
  IncomeFormTaxExemptedIncomeKey,
  TAX_EXEMPTED_INCOME_TYPE_LABELS,
  TEI_TYPE_KEY,
} from '../../../../constants/income-from-tax-exempted-income-constant';

@Component({
    selector: 'app-income-from-tax-exempted-income-en-v2',
    templateUrl: './income-from-tax-exempted-income-en-v2.component.html',
    styleUrls: [
        './income-from-tax-exempted-income-en-v2.component.css',
        '../../../shared/return-view-text-fields.css',
    ],
    standalone: false
})
export class IncomeFromTaxExemptedIncomeEnV2Component implements OnInit {
  @Input() returnData: any;
  @Input() printActive: boolean = false;

  incomeFormTaxExemptedIncomeData: any[] = [];

  readonly teiTypeKey = TEI_TYPE_KEY;

  constructor(private returnViewService: ReturnViewService) { }

  getValue(item: any, key: string): any {
    return item ? item[key] : null;
  }

  getTeiType(item: any): string {
    return String(this.getValue(item, this.teiTypeKey) || '').trim();
  }

  getTaxExemptedIncomeTypeTitle(teiType: any): string {
    const v = teiType === null || teiType === undefined || teiType === '0' ? '' : String(teiType).trim();
    return TAX_EXEMPTED_INCOME_TYPE_LABELS[v] || v;
  }

  isApplicableForType(particular: IncomeFormTaxExemptedIncomeKey, teiType: string): boolean {
    if (!particular.types || particular.types.length === 0) {
      return true;
    }
    return particular.types.includes(teiType);
  }

  getTextParticulars(item: any): IncomeFormTaxExemptedIncomeKey[] {
    const teiType = this.getTeiType(item);
    return INCOME_FORM_TAX_EXEMPTED_INCOME_KEYS
      .filter((k) => k.type === 'text' && this.isApplicableForType(k, teiType))
      .slice()
      .sort((a, b) => a.order - b.order);
  }

  getAmountParticulars(item: any): IncomeFormTaxExemptedIncomeKey[] {
    const teiType = this.getTeiType(item);
    return INCOME_FORM_TAX_EXEMPTED_INCOME_KEYS
      .filter((k) => k.type === 'amount' && this.isApplicableForType(k, teiType))
      .slice()
      .sort((a, b) => a.order - b.order);
  }

  hasParticularValue(item: any, particular: IncomeFormTaxExemptedIncomeKey): boolean {
    const val = this.getValue(item, particular.key);
    if (val === null || val === undefined || val === '') {
      return false;
    }
    if (particular.type === 'amount' && (val === 0 || val === '0')) {
      return false;
    }
    if (particular.key === 'TEI_MODE_OF_REMITTANCE' && (val === '0' || val === 0)) {
      return false;
    }
    return true;
  }

  getDisplayValue(item: any, particular: IncomeFormTaxExemptedIncomeKey): any {
    const val = this.getValue(item, particular.key);

    if (particular.key === 'TEI_MODE_OF_REMITTANCE') {
      switch (String(val || '').trim()) {
        case 'Banking_Channel':
          return 'Banking Channel';
        case 'Foreign_Currency_Declaration_at_Customs_Point':
          return 'Foreign Currency Declaration at Customs Point';
        default:
          return val;
      }
    }

    if (particular.key === 'TEI_IS_MAINTAINED_BOOK_OF_AC') {
      const v = String(val || '').trim();
      if (v === '1') {
        return 'Yes';
      }
      if (v === '0') {
        return 'No';
      }
    }

    if (particular.key === 'TEI_NAME_OF_THE_SCHEME') {
      const schemeLabels: Record<string, string> = {
        probash: 'Probash',
        progoti: 'Progoti',
        surakkha: 'Surakkha',
        samata: 'Samata',
      };
      const v = String(val || '').trim().toLowerCase();
      return schemeLabels[v] || val;
    }

    return val;
  }

  ngOnInit(): void {
    const taxExemptedData = this.returnData?.incomeData?.taxExemptedData;
    this.incomeFormTaxExemptedIncomeData = Array.isArray(taxExemptedData)
      ? taxExemptedData
      : [];
  }
}
